import React from 'react';
import styles from './ParticipantsStats.module.css';

export default function ParticipantsStats({ data }) {
    const metrics = [
        { label: 'الإجمالي',           value: data.total.toLocaleString('ar') },
        { label: 'المتوسط',            value: data.average.toLocaleString('ar') },
        { label: 'الوسيط',             value: data.median.toLocaleString('ar') },
        { label: 'الأقصى',             value: data.max.toLocaleString('ar') },
        { label: 'الأدنى',             value: data.min.toLocaleString('ar') },
        { label: 'متوسط آخر 7 أيام',  value: data.last_7_days_avg.toLocaleString('ar') },
    ];

    return (
        <div className={styles.wrapper}>
            <div className={styles.grid}>
                {metrics.map((m, idx) => (
                    <div key={idx} className={styles.card}>
                        <p className={styles.label}>{m.label}</p>
                        <p className={styles.value}>{m.value}</p>
                    </div>
                ))}
            </div>
            <div className={`${styles.trend} ${styles[data.trend]}`}>
                <span className={styles.trendIcon}>{data.trend === 'up' ? '↑' : '↓'}</span>
                <span>
                    الاتجاه الأسبوعي
                    {data.trend === 'up' ? ' — متوسط المشاركين في ارتفاع' : ' — متوسط المشاركين في انخفاض'}
                </span>
            </div>
        </div>
    );
}
